import { DataServiceConfig } from 'data';
import { environment } from '@rtls-environment/environment';

export const dataServiceConfig: DataServiceConfig = {
	root: environment.thingsApi,
	externalRoot: environment.externalThingsApi,
	usersApi: environment.usersApi,
	entityUrlsMap: {
		locations: 'locations',
		userPreferences: 'user-preferences',
		tenants: 'tenants',
		mileageTracking: 'mileage-tracking',
		inventories: 'inventories',
		alerts: 'alerts',
		transports: 'transports',
		thingDeviceAttachments: 'thing-device-attachments',
		loadingStateStories: 'thing-loading-state-stories',
	},
	assetManagementApi: environment.assetManagementApi,
	notification: {
		url: environment.notification.url,
		path: environment.notification.path,
		scope: environment.auth.scope,
	},
};
